import { TooltipProps } from 'core/tooltip/tooltip.props';

export const TooltipPresets: TooltipProps = {
  content: null,
  position: 'top',
  roundContainer: false,
  visibleOnMobile: true,
};
